export const APP_NAME = "FeeVho";
export const SUPPORT_EMAIL = "info@feevho.com";
export const PRIVACY_EMAIL = "info@feevho.com";